var assignValue = require("./_assignValue"), copyObject = require("./_copyObject"), createAssigner = require("./_createAssigner"), isArrayLike = require("./isArrayLike"), isPrototype = require("./_isPrototype"), keys = require("./keys");
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});
module.exports = assign;
